import { Injectable } from '@angular/core';
import { EndpointService } from './endpoint.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AgentOrgLevel } from '../models/agentOrglevel.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgentOrgLevelService extends EndpointService {

  constructor(http: HttpClient) {
    super(http);
  }

  create(payload: AgentOrgLevel) {
    return this.http.post(this.getApiUrl('AgentOrgLevel/Create'), payload);
  }

  getAssociations(agentId: string, parentOrgLevelId: string, orgLevelType?: number): Observable<AgentOrgLevel[]> {
    let params = new HttpParams()
      .set('agentId', agentId.toString())
    if (parentOrgLevelId !== undefined && parentOrgLevelId !== null) {
      params = params.set('parentOrgLevelId', parentOrgLevelId.toString());
    } else if (orgLevelType !== undefined && orgLevelType !== null) {
      params = params.set('orgLevelType', orgLevelType.toString());
    }
    return this.http.get<AgentOrgLevel[]>(this.getApiUrl('AgentOrgLevel/GetAssociations'), { params });
  }

  delete(agentId: string, orgLevelId: string): Observable<Object> {
    const params = new HttpParams()
      .set('agentId', agentId.toString())
      .set('organizationLevelId', orgLevelId.toString());

    return this.http.delete(this.getApiUrl('AgentOrgLevel/Delete'), { params });
  }
}
